import api, { ApiResponse } from './api';

import { Invitation, GetInvitationProps } from 'entities/Invitation';

interface GetInvitationReponse {
  success: boolean;
  data: Invitation;
}

export const getInvitationService = ({
  token,
}: GetInvitationProps): ApiResponse<GetInvitationReponse> =>
  api({ method: 'GET', url: `invitations/${token}` });
